import { Container } from "@/shared/ui/container/Container";

import styles from "./SectionErrorFallback.module.css";

type SectionErrorFallbackProps = {
  sectionTitle?: string;
};

export function SectionErrorFallback({ sectionTitle }: SectionErrorFallbackProps) {
  const title = sectionTitle
    ? `Не удалось загрузить: ${sectionTitle}`
    : "Не удалось загрузить блок";

  return (
    <Container className={styles.section} role="alert" aria-live="polite">
      <p className={styles.title}>{title}</p>
      <p className={styles.message}>
        Попробуйте обновить страницу позже.
      </p>
    </Container>
  );
}
